import { ledgerbookActionTypes } from "../constants";

const initialState = {
  loading: false,
  data: [],
  error: ""
};

export const ledgers = (state = initialState, action) => {
  switch (action.type) {
    case ledgerbookActionTypes.LEDGER_BOOK_LOADING:
      return {
        ...state,
        loading: true,
        error: ""
      };
    case ledgerbookActionTypes.LEDGER_BOOK__SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: ""
      };
    case ledgerbookActionTypes.LEDGER_BOOK__ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ledgerbookActionTypes.LEDGER_BOOK__RESET:
      return {
        ...state,
        main: [],
      };
    default:
      return state;
  }
};
